var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatformIconA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 49,
    viewBox: "0 0 57 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1395_3244)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92056 1.08887H48.7645C50.2037 1.08887 51.3704 2.25557 51.3704 3.69476V34.0588C51.3704 35.498 50.2037 36.6647 48.7645 36.6647H28.3277V44.1529H23.3575V36.6647H2.92056C1.48137 36.6647 0.314667 35.498 0.314667 34.0588V3.69476C0.314667 2.25557 1.48137 1.08887 2.92056 1.08887ZM34.8246 44.1534H16.8625C16.2603 44.1534 15.7722 44.6415 15.7722 45.2437V47.7278C15.7722 48.33 16.2603 48.8182 16.8625 48.8182H34.8246C35.4268 48.8182 35.9149 48.33 35.9149 47.7278V45.2437C35.9149 44.6415 35.4268 44.1534 34.8246 44.1534Z",
    fill: "url(#paint0_linear_1395_3244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8416 1.08887H48.7645C50.2033 1.08887 51.3704 2.25599 51.3704 3.69476V34.0607C51.3704 35.4994 50.2033 36.6666 48.7645 36.6666H25.8416V1.08887Z",
    fill: "url(#paint1_linear_1395_3244)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4588 11.8097C43.6262 10.1801 41.2196 9.34434 38.771 9.48867C33.6725 9.7874 29.7807 14.1642 30.0794 19.2644C30.3782 24.3629 34.755 28.2548 39.8552 27.956C42.0206 27.8284 44.0627 26.946 45.6331 25.4761L47.5258 27.1589L46.9742 27.7793C46.6621 28.1301 46.694 28.6688 47.0447 28.9809L52.692 34.0022C52.8615 34.1516 53.0813 34.2288 53.3079 34.2154C53.5328 34.2019 53.7442 34.0979 53.8936 33.9284L56.1257 31.4177C56.4378 31.067 56.4059 30.5283 56.0552 30.2161V30.2178L50.4079 25.1982C50.2384 25.0488 50.0186 24.9716 49.792 24.985C49.5671 24.9985 49.3556 25.1008 49.2063 25.2687L48.6565 25.8871L46.7638 24.2043C49.5694 20.4006 49.0611 15.0147 45.4588 11.813V11.8097ZM39.7495 26.256C35.5891 26.4993 32.0195 23.3224 31.7761 19.162C31.5328 15.0017 34.7097 11.4321 38.8701 11.1887C40.8688 11.0662 42.8341 11.7493 44.3277 13.0851C45.8213 14.416 46.7276 16.2855 46.8434 18.2827C47.0867 22.443 43.9098 26.0126 39.7495 26.256ZM53.1871 32.1646L48.8119 28.2744L49.9128 27.0358L54.288 30.926L53.1871 32.1646Z",
    fill: "url(#paint2_linear_1395_3244)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_3244",
    x1: 21.7125,
    y1: 1.73771,
    x2: 21.7125,
    y2: 52.5653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C97FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1395_3244",
    x1: 47.4764,
    y1: 1.08887,
    x2: 26.4249,
    y2: 31.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D84F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1395_3244",
    x1: 33.5251,
    y1: 11.4615,
    x2: 64.5939,
    y2: 38.2524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9AF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1395_3244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.2019,
    height: 47.959,
    fill: "white",
    transform: "translate(0.13855 0.974609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformIconA);
export default __webpack_public_path__ + "static/media/platform_iconA.888b57f322fde50b0391f2c9f376b469.svg";
export { ForwardRef as ReactComponent };